<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="cardSellingTypeData === null">Create Card Selling Type</span>
      <span v-else>Update Card Selling Type</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Price" required
              ><br />
              <a-input-number
                class="w-100"
                v-model.trim="$v.formData.price.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.price.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.price.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Transaction Types">
              <br />
              <a-select
                mode="multiple"
                style="width: 100%"
                v-model="formData.transaction_types"
                :disabled="viewMode"
              >
                <a-select-option value="NEW_MEMBER"
                  >New Member
                </a-select-option>
                <a-select-option value="RENEWAL"> Renewal </a-select-option>
                <a-select-option value="REPLACEMENT">
                  Replacement
                </a-select-option>
                <a-select-option value="LOST_CARD"> Lost Card </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Payment Types">
              <br />
              <a-select
                mode="multiple"
                style="width: 100%"
                v-model.trim="formData.payment_types"
                :disabled="viewMode"
              >
                <a-select-option
                  v-for="paymentType in paymentTypes"
                  :key="paymentType.id"
                  :value="paymentType.id"
                >
                  {{ paymentType.name }}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Status" required>
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="I"> Inactive </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="cardSellingTypeData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createCardSellingType"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editCardSellingType"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CardSellingTypeForm',
  props: {
    cardSellingTypeData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      paymentTypes: [],
      formData: {
        name: null,
        price: null,
        payment_types: [],
        transaction_types: [],
        status: null
      }
    };
  },
  validations: {
    formData: {
      name: { required },
      price: { required }
    }
  },
  methods: {
    async getPaymentTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/payment_types?status=A',
        {
          per_page: 1000
        }
      );
      this.paymentTypes = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async createCardSellingType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        if (this.formData.payment_types) {
          this.formData.payment_types = JSON.stringify(
            this.formData.payment_types
          );
        }
        if (this.formData.transaction_types) {
          this.formData.transaction_types = JSON.stringify(
            this.formData.transaction_types
          );
        }
        const response = await HTTPRequest.postRequest(
          '/api/v1/card_selling_types',
          {
            card_selling_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
        this.formSubmitting = false;
      }
    },
    async editCardSellingType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        if (this.formData.payment_types) {
          this.formData.payment_types = JSON.stringify(
            this.formData.payment_types
          );
        }
        if (this.formData.transaction_types) {
          this.formData.transaction_types = JSON.stringify(
            this.formData.transaction_types
          );
        }
        const response = await HTTPRequest.putRequest(
          '/api/v1/card_selling_types/' + this.cardSellingTypeData.id,
          {
            card_selling_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }

        this.formSubmitting = false;
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        name: null,
        price: null,
        payment_types: [],
        transaction_types: [],
        status: null
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        const { name, price, status } = data;
        let { payment_types, transaction_types } = data;
        transaction_types = JSON.parse(transaction_types);
        payment_types = JSON.parse(payment_types);
        this.formData = {
          name,
          price,
          payment_types,
          transaction_types,
          status
        };
      } else {
        this.clearForm();
      }
    }
  },
  created() {
    this.getPaymentTypes();
    this.setFormData(this.cardSellingTypeData);
  },
  watch: {
    cardSellingTypeData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>

<style scoped></style>
